import {createRouter, createWebHistory} from 'vue-router'
import routes from './routes'
import axios from "axios";
import {toastInstance} from "@/components/toast/Tostify";
import * as Sentry from '@sentry/vue';
import {useUserStore} from '@/stores/userStore';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    linkActiveClass: "active",
});

function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

let authPromise: Promise<boolean>|null = null
const AUTH_CACHE_DURATION = 5 * 60 * 1000
let lastAuthTime = 0

const checkAuth = async () => {
    const now = Date.now()
    if (authPromise && now - lastAuthTime < AUTH_CACHE_DURATION) {
        return authPromise
    }

    authPromise = axios.post<unknown>('/account/auth', ['adminpanel_access'])
        .then(() => {
            lastAuthTime = now
            return true
        })
        .catch(() => {
            lastAuthTime = now
            Sentry.setUser({})
            return false
        })

    return authPromise
}

router.beforeResolve(async (to, from, next) => {
    const userStore = useUserStore();

    if (to.path === '/login') {
        const isAuthenticated = await checkAuth();
        const hasEmail = userStore.checkLogin();

        if (isAuthenticated && hasEmail) {
            return next({name: 'Dashboard'});
        }

        userStore.logout();
        return next();
    }

    const isDashboard = to.path.includes('/dashboard');

    if (isDashboard) {
        const isAuthenticated = await checkAuth();
        const hasEmail = userStore.checkLogin();
        if (isAuthenticated && hasEmail) {
            Sentry.setUser({email: userStore.email!});
            next();
        } else {
            userStore.logout();
            lastAuthTime = 0
            authPromise = null

            const isAuth = await checkAuth();
            if (isAuth) {
                return next();
            }

            toastInstance.error('You are not authorized to access this page', 'Unauthorized');
            next({name: 'Login'});
        }
    } else {
        next();
    }
});


router.beforeEach((to, from, next) => {
    if (to.name !== 'Mobile' && isMobileDevice()) {
        next({name: 'Mobile'})
    } else {
        next()
    }
})

export default router